import React, { useEffect} from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { isAuthenticated } from '../../ProtectedRoute/index'
import {logout} from '../../../actions/authAction';
const Header = () => {
    const dispatch = useDispatch();
    const history = useHistory()
    const { error, logoutError } = useSelector(
      (state) => state.auth
    );
    useEffect(() => {
      if (logoutError) {
        alert.error(logoutError);
        //dispatch({ type: LOGOUT_RESET });
      }
    }, [logoutError, error]);
    const handleLogout = () => {
      dispatch(logout(history));
    };
    return(
      <nav className="navbar navbar-fixed-top">
          <div className="container-fluid">

              <div className="navbar-left">
                  <div className="navbar-btn">
                      <Link to="/"><img src="https://wrraptheme.com/templates/hexabit/html/assets/images/icon-light.svg" alt="Meta Brief" className="img-fluid logo" /></Link>
                      <button type="button" className="btn-toggle-offcanvas"><i className="lnr lnr-menu fa fa-bars"></i></button>
                  </div>
                  {/* <a href="#" className="icon-menu btn-toggle-fullwidth"><i className="fa fa-arrow-left"></i></a> */}
              </div>
              
              <div className="navbar-right">
                  {/* <form id="navbar-search" className="navbar-form search-form">
                      <input className="form-control" placeholder="Search here..." type="text" />
                      <button type="button" className="btn btn-default"><i className="icon-magnifier"></i></button>
                  </form>                 */}

                  <div id="navbar-menu">
                      <ul className="nav navbar-nav">
                          <li><a href="/#" className="right_toggle icon-menu" title="Right Menu"><i className="icon-settings"></i></a></li>
                          {isAuthenticated() && (
                          <li className="nav-item" onClick={() => handleLogout()}>
                             <span className="icon-menu" >
                             <i className="icon-power"></i>
                           </span>
                          </li>)}
                      </ul>
                  </div>
              </div>
          </div>
      </nav>
     
    );
}
export default Header;